import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App, EmbeddedReviewsApp } from "./App";
import "./styles.css";
import "./animations.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
  },
});

const root = document.getElementById("root")!;
const app = root.dataset.embeddedReviews === "true"
  ? <EmbeddedReviewsApp />
  : <BrowserRouter><App /></BrowserRouter>;

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {app}
    </QueryClientProvider>
  </React.StrictMode>,
);
